var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/solid/ic-checkbox-on"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3335 4.66732C1.3335 2.82637 2.82588 1.33398 4.66683 1.33398H11.3335C13.1744 1.33398 14.6668 2.82637 14.6668 4.66732V11.334C14.6668 13.1749 13.1744 14.6673 11.3335 14.6673H4.66683C2.82588 14.6673 1.3335 13.1749 1.3335 11.334V4.66732ZM11.0768 6.99732L7.91016 10.164C7.79683 10.2773 7.65016 10.3306 7.49683 10.3306C7.35016 10.3306 7.2035 10.2773 7.09016 10.164L5.5035 8.58398C5.27683 8.35065 5.27683 7.98398 5.5035 7.75732C5.73016 7.53065 6.1035 7.53065 6.33016 7.75732L7.49683 8.92399L10.2502 6.17065C10.4768 5.94398 10.8502 5.94398 11.0768 6.17065C11.3035 6.40398 11.3035 6.77065 11.0768 6.99732Z",
    fill: "#0132A2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOn);
export default __webpack_public_path__ + "static/media/checkbox-on.f1324917e3ea688c972a2b1c4f56bab5.svg";
export { ForwardRef as ReactComponent };